import orderCustomForm from '@/api/order_custom_form'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    commit('setOrderCustomFormSort', param)

    orderCustomForm.setOrderCustomFormSort(result => {
      resolve(result.data.status)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/actions/setOrderCustomFormSort.js